import isEqual from "lodash/isEqual";
import type { EmailDocument } from "./domain/types";

export function cloneEmailDocumentBaseline(document: EmailDocument): EmailDocument {
  return structuredClone(document);
}

export function emailDocumentsEqual(a: EmailDocument, b: EmailDocument): boolean {
  return isEqual(a, b);
}

export function shouldScheduleEmailBuilderAutosave(state: {
  document: EmailDocument | null;
  autosaveBaselineDocument: EmailDocument | null;
}): boolean {
  if (state.document === null || state.autosaveBaselineDocument === null) {
    return false;
  }

  return !emailDocumentsEqual(state.document, state.autosaveBaselineDocument);
}
